export const withErrorHandler = _ref => {
  let {
    httpClient,
    errorHandler
  } = _ref;
  if (httpClient._requestWasOverridden) {
    return;
  }
  const originalRequest = httpClient.request.bind(httpClient);
  httpClient.request = async requestParams => errorHandler.withErrorHandler(() => originalRequest(requestParams), {
    errorCodesMap: {}
  }).catch(error => {
    throw errorHandler.getResolvedError(error);
  });
  httpClient._requestWasOverridden = true;
};
//# sourceMappingURL=withErrorHandler.js.map